export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/03827f5dae6760b4d294d66a307d6411.png";